import type { IDictionaryIndustry } from '@/creditflowresearch/domain/vo/IDictionary';
import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import { Product } from '@/creditflowresearch/domain/Product';
import Market from '@/creditflowresearch/domain/Market';
import { buildSegmentsQueryParam, NO_SEGMENTS_SELECTED, parseSegmentsQuery } from './segmentQuerySync';

export type TQuery = Record<string, string | string[] | undefined>;

export const SYNCED_QUERY_PARAMS = ['products', 'markets', 'segments'];

const parseSegmentsFromQuery = (
  query: TQuery,
  industries: IDictionaryIndustry[],
): Partial<TFilterPayload> => {
  if (query.segments) {
    return parseSegmentsQuery(query.segments as string, industries);
  }

  const hasProductOrMarketOverride = Boolean(query.products || query.markets);
  return hasProductOrMarketOverride ? NO_SEGMENTS_SELECTED : {};
};

export const parseFiltersFromQuery = (
  query: TQuery,
  industries: IDictionaryIndustry[],
): Partial<TFilterPayload> => ({
  ...(query.products ? { includedProductIds: Product.getIds(query.products as string) } : {}),
  ...(query.markets ? { includedMarketIds: Market.getIds(query.markets as string) } : {}),
  ...parseSegmentsFromQuery(query, industries),
});

export const buildFilterQueryParams = (filters: TFilterPayload, industries: IDictionaryIndustry[]) => ({
  products: Product.getAbbreviations(filters.includedProductIds).join(','),
  markets: Market.getAbbreviations(filters.includedMarketIds).join(','),
  segments: buildSegmentsQueryParam(filters.selectedSubindustryIds, industries),
});
